import { createContext, useContext } from 'react'

export type SidebarContextProps = {
	/** Whether the sidebar is visible (expanded). */
	isOpen: boolean
	/** Current sidebar width in px. */
	width: number
	/** Whether sidebar is in hover-float mode (overlay above content). */
	isFloating: boolean
	/** Toggle sidebar open/closed. */
	toggleSidebar: () => void
	/** Permanently open the sidebar. */
	openSidebar: () => void
	/** Close (collapse) the sidebar. */
	closeSidebar: () => void
	/** Update sidebar width (clamped to min/max). */
	setWidth: (w: number) => void
	/** Update hover-float state. */
	setIsFloating: (v: boolean) => void
	// shadcn compat shims used by existing nav-main, nav-help, etc.
	open: boolean
	setOpen: (open: boolean) => void
	state: 'expanded' | 'collapsed'
	isMobile: boolean
	openMobile: boolean
	setOpenMobile: (open: boolean) => void
}

// Component-free module keeps this context's identity stable across Fast Refresh;
// co-locating it with a component export makes HMR mint a new context and desync the provider.
export const SidebarContext = createContext<SidebarContextProps | null>(null)

export function useSidebar() {
	const ctx = useContext(SidebarContext)
	if (!ctx) {
		throw new Error('useSidebar must be used within a SidebarProvider.')
	}
	return ctx
}
